import { Credentials } from "auth";
import { Organization } from "generated/graphql";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";
import { OrgID } from "routes/Organization/modules";

export type FetchOrganizationList = "FETCH_ORGANIZATION_LIST";
export const FETCH_ORGANIZATION_LIST: FetchOrganizationList = "FETCH_ORGANIZATION_LIST";
export type FetchOrganizationListEnd = "FETCH_ORGANIZATION_LIST_END";
export const FETCH_ORGANIZATION_LIST_END: FetchOrganizationListEnd = "FETCH_ORGANIZATION_LIST_END";

export interface FetchOrganizationListAction extends Action {
    payload: {
        credentials: Credentials;
    };
    type: FetchOrganizationList;
}

export function fetchOrganizationList(): ThunkAction<void, State, undefined, FetchOrganizationListAction> {
    return (dispatch: Dispatch<FetchOrganizationListAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(fetchOrganizationListWithCreds(credentials));
    };
}

function fetchOrganizationListWithCreds(credentials: Credentials): FetchOrganizationListAction {
    return {
        payload: {
            credentials
        },
        type: FETCH_ORGANIZATION_LIST
    };
}

export interface FetchOrganizationListEndAction extends Action {
    payload: {
        organizations?: Organization[];
        lastEvaluatedKey?: string;
        error?: Error;
    };
    type: FetchOrganizationListEnd;
}

export function fetchOrganizationListEnd(error: Error, organizations: OrgID[] = []): FetchOrganizationListEndAction {
    return {
        payload: {
            error,
            organizations: organizations as Organization[]
        },
        type: FETCH_ORGANIZATION_LIST_END
    };
}
